export function ucFirst(string) {
  return string[0].toUpperCase() + string.slice(1);
}

export function cleanString(string = '') {
  string = string && string.trim ? string.trim() : string;

  if (string === 'null') {
    string = undefined;
  }

  return string;
}



// WEBPACK FOOTER //
// ./src/utilities/index.js